export interface RouteItem {
  path: string;
  component: string;
  /** Shown in the header navigation, in this order. */
  nav?: boolean;
  label?: string;
  /** Sends an old path on to its new one, so links from outside keep working. */
  redirect?: string;
}

const routes: RouteItem[] = [
  { path: "/", component: "Home" },
  { path: "/start", component: "GetStarted", nav: true, label: "Get started" },
  { path: "/about", component: "About", nav: true, label: "About" },
  { path: "/adapters", component: "Adapters", nav: true, label: "Adapters" },
  /* The adapters page used to live here. */
  { path: "/features", component: "Adapters", redirect: "/adapters" },
  { path: "/blueprints", component: "Blueprints", nav: true, label: "Blueprints" },
  { path: "/cockpit", component: "BusinessCockpit", nav: true, label: "Business Cockpit" },
  /* Reachable from the About intro and the home page, deliberately not in the
     navigation: it explains the notation, it is not part of the product. */
  { path: "/bpmn", component: "Bpmn" },
  { path: "/features-list", component: "Features" },
  /* Subpage of the Camunda 8 adapter. The slide deep-links every circle to
     /features-list-c8#<ID>, so this path is part of a contract. */
  { path: "/features-list-c8", component: "Coverage" },
];

export default routes;
